(ns common.widgets.template-preview
  (:require ["@mui/material/Stack$default" :as Stack]
            [common.widgets.iframe.view :refer [iframe]]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]))

(defn- scale-dimension
  [dimension scale]
  (.ceil js/Math (* dimension scale)))

(defui no-preview-possible [{:keys [reason-str]}]
  ($ Stack {:justifyContent "center"
            :alignItems "center"
            :sx #js {:height "16rem"
                     :width "16rem"
                     :minWidth "100%"
                     :backgroundColor "grey.70"
                     :borderStyle "solid"
                     :borderWidth 4
                     :borderColor "grey.80"
                     :fontWeight 500
                     :textAlign "center"
                     :whiteSpace "pre-wrap"}
            :data-testid :template-preview-after-effects}
     "No preview possible, \n" reason-str))

(defn card
  [{:keys [scale ref transitioning?] :or {scale 1}}
   {:template/keys [id template-type name width height url]}
   ready-event]
  (if (= template-type "after-effects")
    ($ no-preview-possible {:reason-str "After Effects Template."})
    [:div {:style (merge {:margin "0 auto"
                          :max-width "100%"
                          :width (scale-dimension width scale)
                          :height (scale-dimension height scale)}
                         (when-not @transitioning?
                           {:overflow-x "auto"
                            :overflow-y "hidden"}))
           :data-testid :template-preview-body}
     [:div {:ref ref
            :style {:transform-origin "left top"
                    :transition "transform ease-in-out 0.3s"
                    :transform (str "scale(" scale ")")}}

      [iframe {:id id
               :src url
               :on-ready #(rf/dispatch ready-event)
               :width width
               :height height
               :name name
               :style {:display "block"
                       :border 0}}]]]))
